export default "https://cdn-static-staging.gokick.com/assets/8be3c2df1b703b0455f7e6e91c436c85253a82ea/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";